import { Injectable } from '@angular/core';
import type { DateRange } from 'moment-range';

import { ChartShowModes, Form } from '@site-mate/dashpivot-shared-library';

import { ChartSettings } from 'app/shared/model/charts/chart-settings.model';

import { AreaChartDataParser } from './area-chart-data-parser';
import { BarChartDataParser } from './bar-chart-data-parser';

@Injectable()
export class QuantityChartDataService {
  constructor(
    private readonly barChartDataParser: BarChartDataParser,
    private readonly areaChartDataParser: AreaChartDataParser,
  ) {}

  parseForms(chart: ChartSettings, forms: Form[] = [], dateRange: DateRange) {
    const result = {} as any;

    if (!forms.length) {
      return result;
    }

    switch (chart.showAs) {
      case ChartShowModes.Bar:
        result.barChartData = this.barChartDataParser.parseForms(forms, chart, dateRange);
        result.lineChartData = this.areaChartDataParser.parseForms(
          forms,
          { ...chart, breakdownBy: 'total' },
          dateRange,
        );
        break;
      default:
        result.lineChartData = this.areaChartDataParser.parseForms(forms, chart, dateRange);
    }

    return result;
  }
}
